import { TreeNode } from '../../hooks/stores/launcherElementsStore';

export const removeNodeByID = ({
  treeNode,
  id,
}: {
  treeNode?: TreeNode[];
  id: string;
}): [TreeNode[] | undefined, TreeNode | undefined, string[]] => {
  if (!treeNode) {
    return [undefined, undefined, []];
  }
  let filteredTree: TreeNode[] | undefined = treeNode;
  let removedIDs: string[] = [];

  const foundNode = findNodeByIDRecursively(treeNode, id);
  if (foundNode) {
    removedIDs = getIDsRecursively(foundNode);
  }

  filteredTree = removeNodeByIDRecursively(treeNode, id);

  return [filteredTree, foundNode, removedIDs];
};

const findNodeByIDRecursively = (treeNodes: TreeNode[], idToFind: string): TreeNode | undefined => {
  for (let i = 0; i < treeNodes.length; i++) {
    const treeNode = treeNodes[i];
    if (treeNode.id === idToFind) {
      treeNode.index = i;
      return treeNode;
    }

    if (treeNode.children) {
      const result = findNodeByIDRecursively(treeNode.children, idToFind);
      if (result) {
        return result;
      }
    }
  }

  return undefined;
};

const getIDsRecursively = (treeNode: TreeNode): string[] => {
  const ids: string[] = [treeNode.id];

  if (treeNode.children && treeNode.children.length > 0) {
    for (const child of treeNode.children) {
      ids.push(...getIDsRecursively(child));
    }
  }

  return ids;
};

const removeNodeByIDRecursively = (treeNodes: TreeNode[] | undefined, idToRemove: string): TreeNode[] | undefined => {
  if (!treeNodes) {
    return undefined;
  }

  return treeNodes.reduce<TreeNode[]>((acc, treeNode) => {
    if (treeNode.id === idToRemove) {
      if (treeNode.children && treeNode.children.length > 0) {
        return acc;
      }
    }

    const updatedChildren = removeNodeByIDRecursively(treeNode.children, idToRemove);

    if (updatedChildren) {
      treeNode.children = updatedChildren;
    }

    if (treeNode.id === idToRemove && (!treeNode.children || treeNode.children.length === 0)) {
      return acc;
    }

    acc.push(treeNode);
    return acc;
  }, []);
};
